<template>
  <Sheet>
    <Sheet.Body class="px-5! pt-5 pb-[calc(env(safe-area-inset-bottom)+16px)]">
      <UpdatedTermsBody />
      <Button
        variant="primary"
        size="lg"
        class="mt-6 w-full"
        @click="handleGotIt"
      >
        Got it
      </Button>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { useAcceptTermsMutation } from '@/shared/graphql/legacy/generated'
import UpdatedTermsBody from './UpdatedTermsBody.vue'

const { close, triggerEvent } = useSheet()

const { mutate: acceptTerms } = useAcceptTermsMutation()

const handleGotIt = () => {
  acceptTerms()
  triggerEvent('success')
  close()
}
</script>
